import React from 'react';
import { Button } from '../../../ui';

import line from '../../../../public/images/seo/seyran-line.json';
import { Lottie } from '@crello/react-lottie';

const GetMarketingPlan = () => {
  return (
    <div className="bg-gray relative z-1 overflow-hidden">
      <Lottie
        playingState={'playing'}
        className="rotate-[340deg] md:rotate-0 !w-[1200px] md:!w-full !h-[262px] absolute md:bottom-0 bottom-[140px] md:left-0 -left-[85px] md:top-0 z-[12] md:z-[10]"
        config={{ animationData: line, loop: true }}
      />
      <div className="container relative">
        <div className="relative flex flex-row justify-center">
          <div className="absolute z-[11] w-full max-w-[400px] top-[30px] mr-[20px] left-1/2 transform -translate-x-1/2 md:max-w-[920px] md:h-[64%] h-[84%] rounded-[18px] shadow-[0px_0px_13.5px_0px_rgba(0,82,180,0.32)] bg-white"></div>
          <div className="relative z-[13] flex items-center md:flex-row flex-col-reverse gap-[25px] mt-[50px] md:mt-0 max-w-[350px] w-full md:max-w-[880px]">
            <img src="/images/seo/Sey.png" alt="sey" />
            <div className="flex flex-col gap-[15px] items-center px-[15px]">
              <p className="max-w-[540px] leading-[26px] md:leading-[32px] text-[18px] md:text-[20px] font-[500] text-center">
                Clicking This Button Might Be{' '}
                <span className="block text-[28px] leading-[34px] font-[700] text-[#0052B4] uppercase">the Smartest Investment</span> for Your
                Business to Achieve Better Search Engine Rankings
              </p>
              <div>
                <a href={`/seo/seo-form`} className="w-full">
                  <Button variant="primary" narrowing="both" mode="light" className=" md:text-[18px] text-[15px]">
                    Get a Free Marketing Plan
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetMarketingPlan;
